import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import React from 'react'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import css from './tag.css'
import { getSearchPath } from 'shared/util/search'
import pingbackEnhancer from 'shared/pingbacks/pingback-enhancer'

@pingbackEnhancer()
export default class Tag extends React.PureComponent {
    static propTypes = {
        name: PropTypes.string.isRequired,
        analytics: PropTypes.object.isRequired,
    }

    click() {
        const { name, analytics: { action, category } } = this.props
        googleAnalyticsEvent({
            category,
            action,
            label: name,
        })

        this.props.pingBackFunctions.onClick(this.props)
    }

    onHover() {
        this.props.pingBackFunctions.onHover(this.props)
    }

    render() {
        const { name, isSticker } = this.props
        // make a normal search wihtout appending the word sticker to the search if the search is already sticker or stickers
        const hasWordSticker = name.indexOf('sticker') === -1
        return (
            <a
                ref={el => {
                    this.el = el
                }}
                className={css.pill}
                href={isSticker && hasWordSticker ? getSearchPath(name, true) : getSearchPath(name)}
                onClick={e => this.click(e)}
                onMouseEnter={() => this.onHover()}
            >
                <h3 className={css.tag}>{`#${name}`}</h3>
            </a>
        )
    }
}
